import { Link } from 'react-router-dom';
import { PostThumb, TextHover } from './PostPreviews.jsx';
import { PostPublications } from './PostPublications.jsx';
import { PostActions } from './PostActions.jsx';
import { STATE_LABEL, pillarLabel, fmtAgo } from '../lib/labels.js';

/**
 * One rich post-list row: thumbnail + meta badges + hover title + caption
 * preview + state/publications + actions. THE shared definition — Posts.jsx
 * and ProjectDetail's recent-posts list previously carried near-verbatim
 * copies that had already drifted once (project tag) and would keep
 * drifting (review 2026-08-24). `showProject` adds the project tag on
 * cross-project lists; project-scoped lists omit it.
 */
export function PostListRow({ post: p, showProject = false }) {
  return (
    <Link key={p.id} to={`/posts/${p.id}`} className="post-row post-row-rich">
      <span className="post-title-cell post-title-rich">
        <PostThumb post={p} className="post-thumb-lg" />
        <span className="post-title-body">
          <span className="post-title-meta">
            {showProject && <span className="project-tag">{p.project_name}</span>}
            <span className="pillar-tag">{pillarLabel(p.pillar_key)}</span>
          </span>
          <TextHover post={p}>
            <span className="post-title-text">{p.title || <em>(no title)</em>}</span>
          </TextHover>
          {(p.caption || p.story_text) && (
            <span className="post-title-preview">{p.caption || p.story_text}</span>
          )}
        </span>
      </span>
      <span className="state-cell">
        <span className={`state state-${p.state}`}>{STATE_LABEL[p.state] || p.state}</span>
        <PostPublications post={p} />
      </span>
      <span className="when">{fmtAgo(p.created_at)}</span>
      <PostActions post={p} />
    </Link>
  );
}
